import React, { useState } from "react";
import { Alert, Button, Col, Form, Spinner } from "react-bootstrap";

import "./index.css";

import Email from "../../../email";
import Error from "../../../error";

function ContactOurServicesOnline() {
  const [validated, setValidated] = useState(false);
  const [cellphone, setCellphone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [alertType, setAlertType] = useState("danger");
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if(!loading) {
      setAlertType("danger");
      setAlertMessage("");
      setLoading(true);

      if(form.checkValidity() === false) {
        setAlertMessage("Preencha os campos obrigatórios.");
      }

      setValidated(true);

      const response = await Email.contactOurServices({ data: {
        cellphone,
        email,
        message,
        type,
        name
      }});

      if(response.success === false) {
        const message = Error.getType({ type: response.error.details[0].message });
        if(message) {
          setAlertMessage(message.value);
        }
      }
      else {
        setAlertType("success");
        setAlertMessage("E-mail enviado com sucesso.");
        form.reset();
      }

      setLoading(false);
    }
  };

  return (
    <Form id="form-our-services-online" noValidate validated={validated} onSubmit={handleSubmit}>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>Nome:</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="Nome"
            maxLength="255"
            onChange={e => setName(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Preencha com o seu nome, é obrigatório.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>E-mail:</Form.Label>
          <Form.Control
            required
            type="email"
            placeholder="E-mail"
            onChange={e => setEmail(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Preencha com um email válido, é obrigatório.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>Tipo de ato:</Form.Label>
          <Form.Control as="select"
            required
            type="select"
            placeholder="Tipo do ato"
            onChange={e => setType(e.target.value)}
          >
            <option value="">Selecionar o tipo do ato...</option>
            <option value="D">Escritura</option>
            <option value="P">Procuração</option>
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            Preencha com o tipo do ato, é obrigatório.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>Celular:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Celular"
            onChange={e => setCellphone(e.target.value)}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>Observações:</Form.Label>
          <Form.Control
            required
            as="textarea"
            rows="5"
            placeholder="Mensagem"
            maxLength="1000"
            onChange={e => setMessage(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Preencha com uma mensagem de dúvida, sugestão ou reclamação, é obrigatório.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          {
            alertMessage === "" ? "" : (
              <Alert variant={alertType}>{alertMessage}</Alert>
            )
          }
        </Form.Group>
      </Form.Row>
      <div className="text-right">
        <Button variant="dark" type="submit" disabled={loading ? true : false}>
          {
            loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <></>
            )
          }
          { loading ? " Aguarde..." : " Enviar" }
        </Button>
      </div>
    </Form>
  );
}

export default ContactOurServicesOnline;
